import { lazy, Suspense } from "react"
import { RouteObject } from "react-router"

const Sign = lazy(() => import("@/pkg_act/sign"))
const Free = lazy(() => import("@/pkg_act/free/freeAct"))
const FreeList = lazy(() => import("@/pkg_act/free/freeList"))
const DrawLots = lazy(() => import("@/pkg_act/drawLots"))
const Invite = lazy(() => import("@/pkg_act/invite"))
const SignTask = lazy(() => import("@/pkg_act/signTask"))

const actRouter: RouteObject[] = [
  {
    path: "/sign",
    element: <Sign />,
  },
  {
    path: "/free",
    element: <Free />,
  },
  {
    path: "/freeList",
    element: (
      <Suspense fallback={<></>}>
        <FreeList />
      </Suspense>
    ),
  },
  {
    path: "/drawLots",
    element: <DrawLots />,
  },
  {
    path: "/invite",
    element: <Invite />,
  },
  {
    path: "/signTask",
    element: (
      <Suspense fallback={<></>}>
        <SignTask />
      </Suspense>
    ),
  },
]

export default actRouter
